import { Component, Input } from '@angular/core';
import { UserService } from 'services/user.service';

@Component({
  selector: 'app-login-button',
  templateUrl: './login-button.component.html',
  styleUrls: ['./login-button.component.css']
})
export class LoginButtonComponent {
  @Input() label = 'Login';
  @Input() buttonClass = 'btn btn-default navbar-btn';

  constructor(private _userService: UserService) {}

  login(): void {
    this._userService.login();
  }
}
